import { render } from "./TransactionSummary.vue?vue&type=template&id=8f5a291c"
import script from "./TransactionSummary.vue?vue&type=script&lang=js"
export * from "./TransactionSummary.vue?vue&type=script&lang=js"
script.render = render

export default script